/* Plus-video (snippets/plus-promo-video.liquid, 14-10-2026): twee kleine taken voor de video's op de homepage
   en de Plus-pagina.
   1. Poster: de <video>-elementen dragen de poster in data-poster. Pas als een video dichtbij het scherm komt
      (400 px marge) wordt de poster gezet. Een verborgen variant (display:none) komt nooit in beeld en haalt
      dus geen poster op; een video ver onder de vouw ook niet. Zonder IntersectionObserver krijgen alle
      video's de poster direct.
   2. Meting: GA4-gebeurtenis vp_plus_video via de gtag van het thema, alleen na toestemming voor analytics,
      nooit bij Global Privacy Control en nooit in de editor (dezelfde regel als assets/mijn-vijver-link.js).
      Parameters: vp_bron (home of plus), vp_stap (start, half, klaar), vp_geluid (aan of uit) en vp_versie.
      Per video en per paginabezoek elke stap hoogstens een keer. Geen klant-id, geen opslag, geen eigen netwerk.
   Zonder JavaScript speelt de video gewoon via de knoppen; poster en meting vallen dan weg. */
(function (g) {
  'use strict';
  var VERSIE = 'video-1';
  var BRONNEN = {home: true, plus: true};
  var d = g.document;
  if (!d || typeof d.querySelectorAll !== 'function') return;
  var lijst = d.querySelectorAll('video[data-poster]');
  if (!lijst.length) return;

  function zetPoster(v) {
    var p = v.getAttribute('data-poster');
    if (p && !v.getAttribute('poster')) v.setAttribute('poster', p);
  }

  function toestemming() {
    if (g.navigator && g.navigator.globalPrivacyControl === true) return false;
    if (g.Shopify && g.Shopify.designMode) return false;
    var cp = g.Shopify && g.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() === true;
    return false;
  }

  function meld(v, stap) {
    if (!v.__vcStappen) v.__vcStappen = {};
    if (v.__vcStappen[stap]) return false;
    v.__vcStappen[stap] = true;
    if (!toestemming() || typeof g.gtag !== 'function') return false;
    var bron = v.getAttribute('data-plus-video-bron') || '';
    var p = {
      vp_bron: Object.prototype.hasOwnProperty.call(BRONNEN, bron) ? bron : 'onbekend',
      vp_stap: stap,
      vp_geluid: v.muted ? 'uit' : 'aan',
      vp_versie: VERSIE,
      transport_type: 'beacon'
    };
    try { g.gtag('event', 'vp_plus_video', p); return true; } catch (x) { return false; }
  }

  Array.prototype.forEach.call(lijst, function (v) {
    v.addEventListener('play', function () { meld(v, 'start'); });
    v.addEventListener('timeupdate', function () {
      if (v.duration > 0 && v.currentTime / v.duration >= 0.5) meld(v, 'half');
    });
    v.addEventListener('ended', function () { meld(v, 'klaar'); });
  });

  g.VPPlusVideo = {versie: VERSIE, toestemming: toestemming, meld: meld};

  if (!('IntersectionObserver' in g)) {
    Array.prototype.forEach.call(lijst, zetPoster);
    return;
  }
  var io = new g.IntersectionObserver(function (items) {
    items.forEach(function (it) {
      if (it.isIntersecting) { zetPoster(it.target); io.unobserve(it.target); }
    });
  }, {rootMargin: '400px 0px'});
  Array.prototype.forEach.call(lijst, function (v) { io.observe(v); });
})(typeof window !== 'undefined' ? window : this);
